import publicApi from "../../publicApi";

export const deliveryService = {
  getDeliveryThreshold: async (address) => {
    const response = await publicApi.post("/delivery/threshold/", {
      address: address
    });
    return response.data;
  },
}; 